module.exports = __webpack_public_path__ + "static/features-64d5cb78413800f58141dda4c6daf39a.png";